import { render } from "./App.vue?vue&type=template&id=3725215a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3725215a&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=3725215a&lang=scss"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3725215a"]])

export default __exports__